var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosWorkLeftBg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 298,
    viewBox: "0 0 430 298",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1C1D",
    fillRule: "evenodd",
    stroke: "#000",
    transform: "translate(-30 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.25 129 425.75 129.009 459 185 425.75 241 359.25 241 326 185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.25 184 313.75 184.009 347 240 313.75 296 247.25 296 214 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.25 120 206.75 120.009 240 176 206.75 232 140.25 232 107 176"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 57 99.75 57.009 133 113 99.75 169 33.25 169 0 113"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 179 99.75 179.009 133 235 99.75 291 33.25 291 0 235"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.25 0 211.75 .009 245 56 211.75 112 145.25 112 112 56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.25 64 318.75 64.009 352 120 318.75 176 252.25 176 219 120"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosWorkLeftBg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-work-left-bg.0bda923e.svg";
export { ForwardRef as ReactComponent };